<template>
  <div>    
    <transition name="page-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'nav-home',
  components: { }
};
</script>

<style lang='scss'>
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity .3s
}

.page-fade-enter,
.page-fade-leave-to {
  opacity: 0
}

</style>